import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
let CrfModule = class CrfModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.xtokenModule = '';
        this.listArrayFpk = [];
        this.filterListFpk = [];
        this.fpkErrorSetsTabOne = [];
        this.fpkErrorSetsTabTwo = [];
        this.newObjWeight = {};
        this.totalWeight = 0;
        this.isAllowCreateCRF = null;
        this.loadingFpk = false;
        this.submitInfoDialog = false;
        this.questionAnswer = [];
        this.touched = false;
        this.validationTabOne = true;
        this.validationTabTwo = true;
        this.isSubmitClick = false;
        this.errorMessageFpk = '';
    }
    get getLoadingFpk() {
        return this.loadingFpk;
    }
    get getfpkErrorTabOne() {
        return this.fpkErrorSetsTabOne;
    }
    get getIsAllowCreateCRF() {
        return this.isAllowCreateCRF;
    }
    get getfpkErrorTabTwo() {
        return this.fpkErrorSetsTabTwo;
    }
    get getFilterListFpk() {
        return this.filterListFpk;
    }
    get getNewObjWeight() {
        return this.newObjWeight;
    }
    get getTotalWeight() {
        return this.totalWeight;
    }
    get getListFpk() {
        return this.listArrayFpk;
    }
    get getSubmitInfoDialogFpk() {
        return this.submitInfoDialog;
    }
    ['setLoadingFpk'](data) {
        this.loadingFpk = data;
    }
    ['setfpkErrorTabOne'](data) {
        this.fpkErrorSetsTabOne = data;
    }
    ['editFpkErrorSetsTabOne'](data) {
        if (this.fpkErrorSetsTabOne.length != 0) {
            const index = this.fpkErrorSetsTabOne
                .map((x) => {
                return x.field.name;
            })
                .indexOf(data);
            this.fpkErrorSetsTabOne.splice(index, 1);
        }
    }
    ['setfpkErrorTabTwo'](data) {
        this.fpkErrorSetsTabTwo = data;
    }
    ['editFpkErrorSetsTabTwo'](data) {
        if (this.fpkErrorSetsTabTwo.length != 0) {
            const index = this.fpkErrorSetsTabTwo
                .map((x) => {
                return x.field.id;
            })
                .indexOf(data);
            if (index != -1) {
                this.fpkErrorSetsTabTwo.splice(index, 1);
            }
        }
    }
    ['setFilterListFpk'](data) {
        this.filterListFpk = data;
    }
    ['setXtokenModule'](data) {
        this.xtokenModule = data;
    }
    ['setListFpkClear']() {
        this.listArrayFpk = [];
    }
    ['setListFpk'](data) {
        this.listArrayFpk = data;
    }
    ['setNewObjWeight'](data) {
        this.newObjWeight = data;
    }
    ['setIsanyIsAllowCreateCRF'](data) {
        const listIsAllowCreateCRF = data.data.map((item) => {
            return item.isAllowCreateCRF;
        });
        this.isAllowCreateCRF = listIsAllowCreateCRF.includes(true);
    }
    ['setSubmitInfoDialogFpk'](data) {
        this.submitInfoDialog = data;
    }
    ['getListFpkModule'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/fpkheader/monitoring/multifilter?ver=v1`;
            const parameter = {
                pagingParameter: {
                    pageNumber: params.page,
                    pageSize: params.pageSize,
                    orderColumn: params.orderColumn,
                    orderDir: params.orderDir
                },
                globalSearch: params.globalSearch,
                userLogin: String(params.employeeId),
                pageFilter: params.pageFilter
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, parameter)
                    .then((response) => {
                    const axiosResponse = response.data.result.content;
                    const listFpk = axiosResponse;
                    this.context.commit('setListFpk', listFpk);
                    this.context.commit('setIsanyIsAllowCreateCRF', listFpk);
                    this.context.commit('setIsLoading', false);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['downloadExcel'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/fpkheader/monitoring/multifilterexcel?ver=v1`;
            const parameter = {
                pagingParameter: {
                    pageNumber: params.page,
                    pageSize: params.pageSize,
                    orderColumn: params.orderColumn,
                    orderDir: params.orderDir
                },
                globalSearch: params.globalSearch,
                userLogin: String(params.employeeId),
                pageFilter: params.pageFilter
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, parameter)
                    .then((response) => {
                    window.open(response.data.result.content, '_self', 'download');
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    get getErrorMessageFpk() {
        return this.errorMessageFpk;
    }
    ['setErrorMessageFpk'](data) {
        this.errorMessageFpk = data;
    }
    ['resetStateFpk']() {
        this.questionAnswer = [];
        this.touched = false;
        this.validationTabOne = true;
        this.validationTabTwo = true;
        this.errorMessageFpk = '';
        this.fpkErrorSetsTabOne = [];
        this.fpkErrorSetsTabTwo = [];
        this.isSubmitClick = false;
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLoadingFpk', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setfpkErrorTabOne', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'editFpkErrorSetsTabOne', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setfpkErrorTabTwo', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'editFpkErrorSetsTabTwo', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilterListFpk', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setXtokenModule', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setListFpkClear', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setListFpk', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setNewObjWeight', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsanyIsAllowCreateCRF', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setSubmitInfoDialogFpk', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getListFpkModule', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'downloadExcel', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setErrorMessageFpk', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'resetStateFpk', null);
CrfModule = __decorate([
    Module
], CrfModule);
export default CrfModule;
